package com.eladfinish.bible.contest.screens.openQuestions.ui.dialogs

import androidx.compose.runtime.Composable
import com.eladfinish.bible.contest.SharedRes
import com.eladfinish.bible.contest.data.ChapterData
import com.eladfinish.bible.contest.help
import com.eladfinish.bible.contest.screens.mikud.ui.dialogs.SimpleMessageDialog
import com.eladfinish.bible.contest.screens.names.ui.ChapterDialog
import com.eladfinish.bible.contest.screens.openQuestions.OpenQuestionsAction
import com.eladfinish.bible.contest.screens.openQuestions.OpenQuestionsAction.ToggleHelp
import com.eladfinish.bible.contest.screens.openQuestions.OpenQuestionsState
import com.eladfinish.bible.contest.ui.components.dialogs.GeneralHelpDialog
import com.eladfinish.bible.contest.ui.components.dialogs.HelpContentType.Raw

@Composable
fun OpenQuestionsDialogs(
    dialogState: OpenQuestionsState.DialogState,
    onAction: (OpenQuestionsAction) -> Unit,
    onDismiss: () -> Unit,
    onItemClicked: (Int) -> Unit,
    onChapterDialogTitleClick: (ChapterData) -> Unit,
) {
    when (dialogState) {
        OpenQuestionsState.DialogState.None -> Unit

        is OpenQuestionsState.DialogState.Help -> {
            GeneralHelpDialog(
                titleResource = SharedRes.strings.help,
                helpContentType = Raw(dialogState.content),
                isDontShowAgainChecked = dialogState.isDontShowAgainChecked,
                onApproveDialog = { onAction(ToggleHelp(shouldShowNextTime = it)) },
                onDismiss = onDismiss,
            )
        }

        is OpenQuestionsState.DialogState.TableOfContents -> {
            OpenQuestionsTableOfContents(
                items = dialogState.tableOfContentsItems,
                onDismiss = onDismiss,
                onItemClicked = { index ->
                    onDismiss()
                    onItemClicked(index)
                }
            )
        }

        is OpenQuestionsState.DialogState.ChapterDialog -> {
            ChapterDialog(
                chapterData = dialogState.chapterData,
                onDismiss = onDismiss,
                onTitleClick = {
                    onDismiss()
                    onChapterDialogTitleClick(dialogState.chapterData)
                },
            )
        }

        is OpenQuestionsState.DialogState.GeneralMessage -> {
            SimpleMessageDialog(
                onDismiss = onDismiss,
                title = dialogState.title,
                content = dialogState.content,
            )
        }

        is OpenQuestionsState.DialogState.AddQuestion -> {
            AddQuestionDialog(
                state = dialogState,
                onAction = onAction,
                onDismiss = onDismiss,
            )
        }

        is OpenQuestionsState.DialogState.CustomSheetInput -> {
            CustomSheetInputDialog(
                state = dialogState,
                onAction = onAction,
                onDismiss = onDismiss,
            )
        }
    }
}
